var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.isOrganization
        ? _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "primary" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.showAddTransferDialog.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("transfer")))
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem, index) {
            return _c(
              "v-tab",
              { key: tabItem },
              [
                _c(
                  "v-badge",
                  {
                    staticClass: "notification",
                    attrs: { value: _vm.showBadge(index), color: "red" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "badge",
                          fn: function() {
                            return [_c("div", { attrs: { dark: "" } })]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("span", { staticClass: "tabItem" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(tabItem.toLowerCase())) +
                          "\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(2, function(item, index) {
              return _c(
                "v-tab-item",
                { key: "item" + index },
                [
                  _vm.tabs[index] === "History" &&
                  _vm.tabs[_vm.tab] === "History"
                    ? _c("PaginationController", {
                        attrs: {
                          getDataActionName: "getHistoryTransfers",
                          historyLimit: _vm.historyLimit,
                          haveStartDate: true,
                          actionPredicates: _vm.historyPredicates,
                          refresh: _vm.refresh
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "dataTable",
                              fn: function() {
                                return [
                                  _c("v-data-table", {
                                    staticClass: "elevation-2 myDense",
                                    attrs: {
                                      headers: _vm.headerHistory,
                                      items: _vm.transferHistory,
                                      "hide-actions": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.index + 1)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c("v-flex", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              props.item
                                                                .transactionId
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      props.item.messages &&
                                                      props.item.messages.length
                                                        ? _c(
                                                            "v-flex",
                                                            {
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.showMessagesPopup(
                                                                    props.item
                                                                      .messages ||
                                                                      []
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "blue"
                                                                  }
                                                                },
                                                                [_vm._v("info")]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  class:
                                                    _vm.selectedType === 2
                                                      ? "text-xs-left font-green"
                                                      : "text-xs-left"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.fromName)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  class:
                                                    _vm.selectedType === 1
                                                      ? "text-xs-left font-green"
                                                      : "text-xs-left"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.toName)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._l(
                                                    props.item.items,
                                                    function(item, index) {
                                                      return _c(
                                                        "v-flex",
                                                        {
                                                          key: "item" + index,
                                                          attrs: { row: "" }
                                                        },
                                                        [
                                                          _c("ProductWidget", {
                                                            attrs: {
                                                              name: item.name,
                                                              condition:
                                                                item.condition,
                                                              upc: item.upc
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "info",
                                                                  fn: function() {
                                                                    return [
                                                                      _c(
                                                                        "v-flex",
                                                                        {
                                                                          staticClass:
                                                                            "text-xs-right",
                                                                          staticStyle: {
                                                                            "white-space":
                                                                              "nowrap"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "$" +
                                                                              _vm._s(
                                                                                (
                                                                                  item.unitPrice ||
                                                                                  0
                                                                                ).toLocaleString()
                                                                              ) +
                                                                              " * " +
                                                                              _vm._s(
                                                                                item.toShip
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  },
                                                                  proxy: true
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          class: _vm.noteClass
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.item.note
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    "                    \n                  $" +
                                                      _vm._s(
                                                        props.item.items
                                                          .reduce(function(
                                                            acc,
                                                            item
                                                          ) {
                                                            return (
                                                              acc +
                                                              (item.unitPrice ||
                                                                0) *
                                                                item.toShip
                                                            )
                                                          },
                                                          0)
                                                          .toLocaleString()
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item
                                                            .warehouseName
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-layout", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          props.item.location
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.userName)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        props.item.isCanceled
                                                          ? "canceled"
                                                          : props.item.isPending
                                                          ? "pending"
                                                          : "added"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.toTimestampString(
                                                        props.item.createTime
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  props.item.files
                                                    ? _c(
                                                        "v-flex",
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                flat: "",
                                                                disabled: !props
                                                                  .item.files
                                                                  .length
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.downloadFile(
                                                                    props.item
                                                                      .files
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "attachment"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "beforeMenu",
                              fn: function() {
                                return [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        lg6: "",
                                        "d-flex": "",
                                        "align-baseline": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { sm5: "" } },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.types,
                                              label: _vm.$t("type"),
                                              "item-text": "name",
                                              "item-value": "type"
                                            },
                                            model: {
                                              value: _vm.selectedType,
                                              callback: function($$v) {
                                                _vm.selectedType = $$v
                                              },
                                              expression: "selectedType"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-flex", { attrs: { sm1: "" } }),
                                      _vm._v(" "),
                                      _vm.selectedType >= 1 &&
                                      _vm.selectedType <= 3
                                        ? _c(
                                            "v-flex",
                                            { attrs: { sm6: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  "append-icon": "filter_list",
                                                  label: _vm.$t(
                                                    _vm.selectedType === 3
                                                      ? "transactionID"
                                                      : "organizationName"
                                                  )
                                                },
                                                on: {
                                                  keyup: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    _vm.refresh = !_vm.refresh
                                                  }
                                                },
                                                model: {
                                                  value: _vm.searchName,
                                                  callback: function($$v) {
                                                    _vm.searchName = $$v
                                                  },
                                                  expression: "searchName"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectedType === 4
                                        ? _c(
                                            "v-flex",
                                            { attrs: { sm6: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  items:
                                                    _vm.organizationsForSelect,
                                                  "item-text": "displayName",
                                                  "item-value": "key",
                                                  label: _vm.$t("transactionID")
                                                },
                                                model: {
                                                  value: _vm.organizationKey,
                                                  callback: function($$v) {
                                                    _vm.organizationKey = $$v
                                                  },
                                                  expression: "organizationKey"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.transferHistory,
                          callback: function($$v) {
                            _vm.transferHistory = $$v
                          },
                          expression: "transferHistory"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabs[index] === "Pending" &&
                  _vm.tabs[_vm.tab] === "Pending"
                    ? _c(
                        "v-layout",
                        {
                          attrs: { "justify-start": "", "align-baseline": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "success--text caption" },
                            [
                              _c(
                                "span",
                                { staticClass: "realtime-border px-1" },
                                [_vm._v(_vm._s(_vm.$t("realTIME")))]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tabs[index] === "Pending" &&
                  _vm.tabs[_vm.tab] === "Pending"
                    ? _c("v-data-table", {
                        staticClass: "elevation-2 myDense",
                        attrs: {
                          headers: _vm.headerPending,
                          items: _vm.pendingTransfers,
                          "item-key": "_key",
                          "rows-per-page-items": _vm.rowPerPage
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c("td", { staticClass: "text-xs-center" }, [
                                    _vm._v(_vm._s(props.index + 1))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-left" },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c("v-flex", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  props.item.transactionId
                                                ) +
                                                "\n                "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          props.item.messages &&
                                          props.item.messages.length
                                            ? _c(
                                                "v-flex",
                                                {
                                                  staticStyle: {
                                                    cursor: "pointer"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showMessagesPopup(
                                                        props.item.messages ||
                                                          []
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "blue"
                                                      }
                                                    },
                                                    [_vm._v("info")]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.fromName))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.toName))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-left" },
                                    [
                                      _vm._l(props.item.items, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "v-flex",
                                          {
                                            key: "item" + index,
                                            attrs: { row: "" }
                                          },
                                          [
                                            _c("ProductWidget", {
                                              attrs: {
                                                name: item.name,
                                                condition: item.condition,
                                                upc: item.upc
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  !_vm.upcs.has(item.upc)
                                                    ? {
                                                        key: "btn",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                attrs: {
                                                                  md1: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "25px",
                                                                      height:
                                                                        "25px",
                                                                      margin:
                                                                        "0px"
                                                                    },
                                                                    attrs: {
                                                                      fab: "",
                                                                      dark: "",
                                                                      color:
                                                                        "blue"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.createProductFromTransfer(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          dark:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "add"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    : null,
                                                  {
                                                    key: "info",
                                                    fn: function() {
                                                      return [
                                                        !_vm.transferInModify[
                                                          props.index
                                                        ]
                                                          ? _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "text-xs-right",
                                                                staticStyle: {
                                                                  "white-space":
                                                                    "nowrap"
                                                                },
                                                                attrs: {
                                                                  md4: ""
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    "$" +
                                                                      _vm._s(
                                                                        (
                                                                          item.unitPrice ||
                                                                          0
                                                                        ).toLocaleString()
                                                                      ) +
                                                                      " * " +
                                                                      _vm._s(
                                                                        item.toShip
                                                                      )
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                item.initUnitPrice
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "strikethrough"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "($" +
                                                                            _vm._s(
                                                                              (
                                                                                item.initUnitPrice ||
                                                                                0
                                                                              ).toLocaleString()
                                                                            ) +
                                                                            " * " +
                                                                            _vm._s(
                                                                              item.toShip
                                                                            ) +
                                                                            ")"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            )
                                                          : _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "text-xs-right",
                                                                staticStyle: {
                                                                  "white-space":
                                                                    "nowrap"
                                                                },
                                                                attrs: {
                                                                  md2: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    model: {
                                                                      value:
                                                                        item.unitPrice,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "unitPrice",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "item.unitPrice"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            { class: _vm.noteClass },
                                            [_vm._v(_vm._s(props.item.note))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(
                                      "                    \n              $" +
                                        _vm._s(
                                          props.item.items
                                            .reduce(function(acc, item) {
                                              return (
                                                acc +
                                                (item.unitPrice || 0) *
                                                  item.toShip
                                              )
                                            }, 0)
                                            .toLocaleString()
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-left" },
                                    [
                                      _c("v-layout", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.item.warehouseName) +
                                            "\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("v-layout", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.item.location) +
                                            "\n              "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(_vm._s(props.item.userName))
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-xs-left" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.toTimestampString(
                                          props.item.createTime
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "text-xs-left" },
                                    [
                                      _vm.transferInModify[props.index]
                                        ? _c(
                                            "v-layout",
                                            { attrs: { "justify-center": "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    loading:
                                                      _vm.transferInModify[
                                                        props.index
                                                      ] === "loading",
                                                    flat: "",
                                                    small: "",
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveProductPrice(
                                                        props.item,
                                                        props.index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("check")
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    icon: "",
                                                    flat: "",
                                                    disabled:
                                                      _vm.transferInModify[
                                                        props.index
                                                      ] === "loading"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.cancelModifyProductPrice(
                                                        props.item,
                                                        props.index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { color: "red" } },
                                                    [_vm._v("cancel")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm.isOrganization &&
                                          !_vm.transferInModify[props.index]
                                        ? _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "justify-space-between": ""
                                              }
                                            },
                                            [
                                              props.item.to ===
                                              _vm.isOrganization
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      !props.item.userKey
                                                        ? _c("LoaderButton", {
                                                            attrs: {
                                                              buttonText: _vm.$t(
                                                                "add"
                                                              ),
                                                              promiseAwait:
                                                                _vm.addTransferToInventory,
                                                              promiseItem:
                                                                props.item,
                                                              flat: true,
                                                              disabled: !_vm.isUpcFullfilled(
                                                                props.item.items
                                                              )
                                                            }
                                                          })
                                                        : _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                flat: "",
                                                                disabled: !_vm.isUpcFullfilled(
                                                                  props.item
                                                                    .items
                                                                )
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  return _vm.showAddToInventoryDialog(
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t("add")
                                                                )
                                                              )
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isOrganization
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c("LoaderButton", {
                                                        attrs: {
                                                          buttonText: _vm.$t(
                                                            props.item.to ===
                                                              _vm.$store.getters
                                                                .activeOrganization
                                                              ? "reject"
                                                              : "cancel"
                                                          ),
                                                          promiseAwait:
                                                            _vm.cancelTransfer,
                                                          promiseItem:
                                                            props.item,
                                                          flat: true
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              props.item.files
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            flat: "",
                                                            disabled: !props
                                                              .item.files.length
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.downloadFile(
                                                                props.item.files
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "attachment"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              props.item.to ===
                                                _vm.isOrganization &&
                                              props.item.isModifiable
                                                ? _c(
                                                    "v-flex",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            flat: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modifyTransferProductPrice(
                                                                props.item,
                                                                props.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "modifyPrice"
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.addTransferDialog
        ? _c("ProductTransferPopup", {
            attrs: {
              title: _vm.$t("newTransfer"),
              actionFunc: _vm.createTransfer,
              rightButtonText: _vm.$t("submit"),
              large: ""
            },
            model: {
              value: _vm.addTransferDialog,
              callback: function($$v) {
                _vm.addTransferDialog = $$v
              },
              expression: "addTransferDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addProductDialog
        ? _c("ProductEdit", {
            attrs: {
              title: _vm.$t("addProduct"),
              actionText: _vm.$t("add"),
              upcReadOnly: "",
              actionFunc: _vm.addProduct,
              product: _vm.productInEdit
            },
            model: {
              value: _vm.addProductDialog,
              callback: function($$v) {
                _vm.addProductDialog = $$v
              },
              expression: "addProductDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.addToInventoryDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("pendingPeriod"),
              rightMethod: function() {
                return _vm.addTransferToInventory(
                  Object.assign({}, _vm.transferInEdit, {
                    pendingPeriod: _vm.pendingPeriod
                  })
                )
              },
              rightButtonText: _vm.$t("submit"),
              small: ""
            },
            on: {
              popupClose: function() {
                _vm.addToInventoryDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-text-field", {
                                staticClass: "required_field",
                                attrs: {
                                  label: _vm.$t("pendingPeriod"),
                                  rules: [
                                    _vm.fieldIsRequired("Pending period"),
                                    _vm.fieldIsInteger("Pending period"),
                                    _vm.fieldIsNoLessThanZero("Pending period")
                                  ]
                                },
                                model: {
                                  value: _vm.pendingPeriod,
                                  callback: function($$v) {
                                    _vm.pendingPeriod = _vm._n($$v)
                                  },
                                  expression: "pendingPeriod"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              258649169
            ),
            model: {
              value: _vm.addToInventoryDialog,
              callback: function($$v) {
                _vm.addToInventoryDialog = $$v
              },
              expression: "addToInventoryDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("LabelErrorPopup", {
        attrs: {
          title: _vm.$t("transferErrorLog"),
          messages: _vm.messages || []
        },
        model: {
          value: _vm.showMessagesDialog,
          callback: function($$v) {
            _vm.showMessagesDialog = $$v
          },
          expression: "showMessagesDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9cb75578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cb75578","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductTransferTenant.vue
// module id = null
// module chunks = 